<!--<cs-sidepanel id="signatureForm"-->
<!--              [show]="showSignatureSidePanel"-->
<!--              [name]="'signatureForm'"-->
<!--              (close)="onSidepanelClose()"-->
<!--              class="ltc-sidepanel dynamic-cert-sidepanel add-edit-cert-side-panel" [ngClass]="{'custom-fields': screenFor!=0}">-->

  <!-- Panel title -->
<div class="signature-container">
  <div class="modal-header">Signature</div>
  <div class="modal-body">
    <div class="body-content-section">
      <div class="row-fluid">
        <div class="span12">
          <div class="control-group">
            <label class="control-label required_field" translate>Your.name</label>
            <div class="controls">
              <input type="text" class="control-input" [(ngModel)]="signatureText" />
            </div>
          </div>

          <div class="signature-cont">
            <app-cs-signature-generator *ngIf="signatureText"
                                        [signatureText]="signatureText"
                                        imageHeight="130"
                                        imageWidth="350"
                                        (signatureAsBase64)="getSignature($event)">
            </app-cs-signature-generator>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="buttons">
      <a (click)="onSidepanelClose()" translate id="cancel-panel-btn" href="javascript: void(0)">
        Cancel
      </a>
      <button [disabled]="!base64Image"
              (click)="insertSignature()"
              class="btn btn-primary primary-button">
        <span translate>Insert</span>
      </button>
    </div>
  </div>
</div>
